import { Box, Typography } from '@mui/material';
import PhoneCall from '../../../assets/Icons/phone-call';
import K2Logo from '../../../assets/images/K2-Logo.png';
import K2Bg from '../../../assets/images/k2-background.png';

const OnboardingSidebar = ({
  steps,
  currentStep,
}: {
  steps: string[];
  currentStep: number;
}) => {
  return (
    <Box
      sx={{
        height: '100vh',
        borderRadius: '0 20px 20px 0',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          width: '100%',
          height: '100%',
          position: 'absolute',
          left: 0,
          top: 0,
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            background: 'rgba(0, 0, 0, 0.75)',
            height: '100%',
            width: '100%',
          }}
        />
        <img
          src={K2Bg}
          style={{
            height: '100%',
            background: 'rgba(0, 0, 0, 0.75)',
          }}
        />
      </Box>
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          zIndex: 999,
          height: '100%',
          width: '100%',
          padding: '24px',
          boxSizing: 'border-box',
        }}
      >
        <img src={K2Logo} style={{ width: '42px' }} />
        <Box
          sx={{ display: 'flex', flexDirection: 'column', alignItems: 'end' }}
        >
          {steps.map((step, index) => {
            return (
              <>
                {index !== 0 && (
                  <Box sx={{ padding: '8px 24px' }}>
                    <Box
                      sx={{
                        height: '64px',
                        width: '2px',
                        backgroundColor:
                          index <= currentStep ? '#3293DB' : '#655C68',
                      }}
                    />
                  </Box>
                )}
                <Box
                  sx={{ display: 'flex', alignItems: 'center', gap: '15px' }}
                >
                  <Typography
                    sx={{
                      fontSize: '18px',
                      fontWeight: 700,
                      color: 'white',
                      textAlign: 'end',
                    }}
                  >
                    {step}
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minWidth: '50px',
                      maxWidth: '50px',
                      height: '50px',
                      borderRadius: '100%',
                      background:
                        index <= currentStep
                          ? 'radial-gradient(50% 50% at 50% 50%, #52A3E0 0%, #1E70AE 100%)'
                          : '#655C68',
                      color: 'white',
                    }}
                  >
                    {index + 1}
                  </Box>
                </Box>
              </>
            );
          })}
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          <PhoneCall />
          <Typography
            sx={{ fontSize: '14px', color: 'white', whiteSpace: 'nowrap' }}
          >
            Need help? Call 801.709.3535
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default OnboardingSidebar;
